import { gql } from '@apollo/client'

export const TEMPLATE_ACTION_MUTATION = gql`
    mutation performTemplateAction($request: TemplateActionRequest) {
        performTemplateAction(request: $request)
    }
`

